import HomePage from './pages/home';
import configureHttp from './http/axios.http';

export default function Root(props) {
    /**
     * for configuring the axios keepAlive agent for connection pool
     */
    configureHttp();

    const passingProps = props.getCPTTInputs
        ? { ...props.getCPTTInputs(), embedded: true }
        : { ...props, embedded: false };

    return <HomePage {...passingProps} />;
}
